<template>
  <section>
    <b-tabs>
      <b-tab title="Shipping" lazy>
        <shipping-tab />
      </b-tab>
      <b-tab title="Receiving" lazy>
        <receiving-tab />
      </b-tab>
    </b-tabs>
  </section>
</template>

<script>
import ShippingTab from './tabs/ShippingTab';
import ReceivingTab from './tabs/ReceivingTab';

export default {
  components: {
    ShippingTab,
    ReceivingTab
  }
}
</script>
